import { graphql } from '@/gql';
import type { FetchPartnerQuery, FetchPartnerQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

// Fragments
import './fragments/callOptionsFragment';
import './fragments/emailOptionsFragment';
import './fragments/mailOptionsFragment';
import './fragments/mailOptionsFragment';

export type FetchPartnerInput = FetchPartnerQueryVariables;

export type FetchPartnerOutput = FetchPartnerQuery['partner'];

export type PartnerUser = NonNullable<NonNullable<FetchPartnerOutput>['users']>[number];

export const fetchPartner = async ({ codeName, id }: FetchPartnerInput): Promise<FetchPartnerOutput> => {
  const response = await queryExecute({
    query: graphql(`
      query FetchPartner($id: Float, $codeName: String) {
        partner(id: $id, codeName: $codeName) {
          id
          name
          codeName
          callCenterNumber
          gogoNumber
          extension
          phoneNumber
          email
          streetAddress
          streetAddress2
          city
          state
          country
          zip
          latitude
          longitude
          timeZone
          website
          stripeCustomerId
          subsidyType
          subsidyAmt
          membersFlatFee
          maxSubsidyAmt
          credits
          creditsAmtMin
          creditsRenewedAt
          creditsRenewNum
          creditsRenewNumType
          maxRides
          maxRidesRenewedAt
          maxRidesRenewNum
          maxRidesRenewNumType
          subsidyCondition
          rideType
          description
          infoForDriver
          infoForOperator
          isApprovedAddressPartner
          isScheduledRideRestricted
          contactFirstName
          contactLastName
          contactPhoneNumber
          contactEmail
          websiteRegistration
          websiteDashboard
          numberOfRides
          notes
          isDisabled
          isAutoConfirmSurge
          ridePaymentTier
          specialRequestTier
          pharmacyPaymentTier
          gourmetPaymentTier
          groceryPaymentTier
          operatorOrderedRidePrice
          subsidyDescription
          subsidyLocations
          isIncludeInMoveUserIntoPartnershipForm
          isHideRegistrationLink
          isSendRenewalNotification
          turnOnRideOrderingLPAlert
          isRecordAllCalls
          isRollsOverMaxRides
          isNotChargeForCancellationFees
          isNotCountCanceledRides
          isEmailReceipt
          isPartnerWantEmailReceiptToMemberEvenIf100PercentSubsidy
          partnerHours {
            day
            partnerId
            start
            end
          }
          scheduledRideConfirmedEmail
          scheduledRideReminderDayBeforeEmail
          scheduledRideReminderMinutesAfterCreation
          scheduledRideCancelledSms
          membershipType
          membershipAmount
          isSendWelcomeKits
          isShowUserPersonalRidesOnPartnerDashboard
          maxCallers
          plan
          planData {
            durationSize
            durationUnit
            isAutoRenewal
            isEditableDates
            isStartDateEditable
            notificationDays
          }
          enrollmentCriteria {
            minAge
            useGeofence
          }
          noCrm
          abTestOptions
          transactionalSms
          noMail
          marketingMail
          isAlwaysOperator
          smsOptions {
            ...SmsOptionsFragment
          }
          emailOptions {
            ...EmailOptionsFragment
          }
          callOptions {
            ...CallOptionsFragment
          }
          mailOptions {
            ...MailOptionsFragment
          }
          allowCallersVoipPhoneNumbers
          welcomeMessageUrl
          logoUrl
          collectCc
          transactionalMail
          marketingEmails
          transactionalEmails
          transactionalEmails
          marketingRobocalls
          transactionalRobocalls
          noRobocalls
          marketingSms
          transactionalSms
          isBulkCharge
          isAllowCustomerTip
          users {
            id
            firstName
            lastName
            email
            highestRole
            isActive
          }
          rideAllowance {
            tiers {
              name
              allowance
            }
          }
          newSubsidy
          memberGroups
          serviceCode
        }
      }
    `),
    variables: {
      id,
      codeName,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.partner;
};
